<template>
  <div class="d-flex align-center">
    <h5
      data-testid="jira-issue-attachments-length"
      class="w-20 font-weight-bold"
    >
      Attachments ({{ attachments.length }})
    </h5>
    <div class="d-flex gap-2 w-80 flex-wrap">
      <v-card
        v-for="file in attachments"
        :key="file.id"
        class="w-100 flex-basis-32"
      >
        <v-card-text class="ow-anywhere">
          <v-img
            :data-testid="`jira-issue-attachment-img-${file.id}`"
            :width="300"
            aspect-ratio="16/9"
            cover
            :src="file.thumbnail"
          />
          <SoLink
            :data-testid="`jira-issue-attachment-link-${file.id}`"
            :text="file.filename"
            :href="file.thumbnail"
          />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoLink from "@/components/SoLink.vue"
  import { AttachmentType } from "@/models/jiraIssue/jiraIssue.types"

  export default defineComponent({
    components: { SoLink },
    props: {
      attachments: {
        type: Array as PropType<AttachmentType[]>,
        default: [] as AttachmentType[],
        required: true,
      },
    },
  })
</script>

<style scoped>
  .w-20 {
    min-width: 20%;
  }

  .w-80 {
    width: 80%;
  }

  .ow-anywhere {
    overflow-wrap: anywhere;
  }

  .flex-basis-32 {
    flex-basis: 32%;
  }
</style>
